// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"18333":"589d8a59a4be3154","67325":"fc2acf5697a30d7c","89318":"10cec4da7984f239"}[chunkId] + ".css";
};